module.exports = __webpack_public_path__ + "img/step2_4.b3934740.jpg";